import { ReactNode, useId } from 'react';
import { cn } from 'utils/style-utils';

export interface FormSectionProps {
  title?: string;
  className?: string;
  children: ReactNode;
}

/** A titled block of a creation form; the drawer draws the dividers between blocks. */
const FormSection = ({ title, className, children }: FormSectionProps) => {
  const titleId = useId();

  return (
    <section
      aria-labelledby={title ? titleId : undefined}
      className={cn('flex flex-col gap-3 p-4', className)}
    >
      {title && (
        <span id={titleId} className="text-sm font-semibold text-gray-900">
          {title}
        </span>
      )}
      {children}
    </section>
  );
};

export default FormSection;
